import createMatcher from 'feather-route-matcher'

const PREDEFINED_REDIRECTS = {
	"/p/:hashid": "https://selecao.picsize.com.br/:hashid/preview/p",
	"/g/:hashid": `${window.location.origin}/:hashid`,
	"/s/:hashid": `${window.location.origin}/:hashid`,
	"/s/:hashid/:subpage": "https://selecao.picsize.com.br/:hashid/select/:subpage",
	"/s/:hashid/:subpage/:picid": "https://selecao.picsize.com.br/:hashid/select/:subpage/:picid",
	"/index.html/:hashid": `${window.location.origin}/:hashid`
}

export const makePredefinedRedirectIfNeeded = async () => {
	return new Promise(resolve => {
		const matcher = createMatcher(PREDEFINED_REDIRECTS)

		const needsPredefinedRedirect = matcher(window.location.pathname)
		// In case this variable is null, it means that the current pathname
		// does not match any of predefined redirect rules, so it doesn't need
		// to be redirected
		if (!needsPredefinedRedirect) {
			return resolve()
		}

		const { params, page } = needsPredefinedRedirect

		let urlToRedirect = page.value || page

		Object.keys(params).forEach(key => {
			urlToRedirect = urlToRedirect.replace(`:${key}`, params[key])
		})

		return window.location = urlToRedirect
	})
}

export const makeCallbackRedirectIfNeeded = async (queryParams, frontData) => {
	return new Promise(resolve => {
		// The pages you don't want this redirect to work	
		const blackListPages = ["signup", "login"]

		const pathname = window.location.pathname
		const isBlackListPage = blackListPages.some(page => pathname.includes(page))

		// In case the user tried to log in by clicking on the select mode
		// we previously set up a call back to go automatically there without
		// having to click on the button again
		if (queryParams.callback === "select_mode" && frontData.selection_url && !isBlackListPage) {
			return (window.location = frontData.selection_url)
		}

		// In case the user tried to log in by clicking on the gallery mode
		// we previously set up a call back to go automatically there without
		// having to click on the button again
		if (queryParams.callback === "preview_mode" && frontData.gallery_url && !isBlackListPage) {
			return (window.location = frontData.gallery_url)
		} 
		
		// When the user shares his gallery, it is basically the link
		// of this platform with a query param specifying the kind of sharing
		// so if it as gallery one we redirect user to gallery
		if (queryParams.share === "gallery" && frontData.gallery_url) {		
			return (window.location = `${frontData.gallery_url}?share=gallery`)
		}

		return resolve()
	})
}

export const makePageRefreshIfNeeded = async (frontData, customerData, hash) => {
	return new Promise(resolve => {
		// In case the hash on url is not the same of the hash given by the back-end
		if (frontData.hash && frontData.hash !== hash) {
			return (window.location.pathname = `/${frontData.hash}`)
		}

		// In case the current subdomain is not the same of the customer
		const [subdomain] = window.location.hostname.split('.')
		if (process.env.NODE_ENV !== 'development' && customerData.subdomain !== subdomain && frontData.home_url) {
			return (window.location = frontData.home_url)
		}

		return resolve()
	})
}